import React, { Fragment, useState } from "react";

import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  useTheme,
  darken,
  Typography
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";
import { RESOURCE_GROUPS } from "../../../constants/potato";

export const ResourceDrawerList = () => {
  const [resourceSectionOpen, setResourceSectionOption] = useState({});
  const theme = useTheme();

  const toggleSubmenu = (event, resource) => {
    event.preventDefault();
    event.stopPropagation();

    setResourceSectionOption((prev) => {
      return {
        ...prev,
        [resource.label]: !prev[resource.label]
      };
    });
  };

  return (
    <List>
      {RESOURCE_GROUPS.map((resource) => (
        <Fragment key={resource.label}>
          <ListItemButton
            data-testid={`nav-${resource.label}`}
            onClick={(event) => toggleSubmenu(event, resource)}
          >
            <ListItemText disableTypography>
              <Typography fontWeight={500} letterSpacing={2}>
                {resource.label}
              </Typography>
            </ListItemText>
            {resourceSectionOpen[resource.label]
              ? (
                <ExpandLess />
              )
              : (
                <ExpandMore />
              )}
          </ListItemButton>
          <Collapse
            in={resourceSectionOpen[resource.label]}
            timeout="auto"
            unmountOnExit
          >
            <List
              component="div"
              disablePadding
              sx={{
                background: darken(theme.palette.primary.dark, 0.1)
              }}
            >
              {resource.items.map((item) => (
                <ListItemButton
                  key={item.label}
                  component={item.external ? "a" : NavLink}
                  end={!item.external}
                  to={!item.external ? item.url : undefined}
                  href={item.external ? item.url : undefined}
                  aria-label={`Go to ${item.label}`}
                  sx={{
                    pl: 4,
                    "&.active": {
                      background: darken(theme.palette.primary.dark, 0.225)
                    }
                  }}
                >
                  <ListItemText>{item.label}</ListItemText>
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </Fragment>
      ))}
    </List>
  );
};
